import { Accordion } from '@cinch-nx/shared-ui'
import { StoryEvFaqs } from '../../types/electric-cars-page'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'
import { FAQQuestion } from '@cinch-nx/data-storyblok'
import sharedStyles from '../../landing-feature-electric-cars.module.css'

interface EvFaqsProps {
  title: StoryEvFaqs['title']
  faqs: StoryEvFaqs['faqs']
}

export const EvFaqs = ({ title, faqs }: EvFaqsProps) => {
  const accordionItems = faqs.map((faq: FAQQuestion) => ({
    title: faq.title,
    children: () => <>{renderWithResolver(faq.body)}</>,
  }))
  return (
    <section>
      <h3 id="faq-section" className={sharedStyles.heading}>
        {title}
      </h3>
      <Accordion
        title={title}
        items={accordionItems}
        buttonId={title}
        sectionId="ev-faq-section"
      />
    </section>
  )
}
